import React from "react";
import PropTypes from "prop-types";
import {Typography, Box, Button, makeStyles, Grid} from "@material-ui/core";
import {useI18N} from "../../../common/common";
import StreamlineIcon from "../../widget/streamline-icon/StreamlineIcon";
import ArrowLeft from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/arrows-diagrams/arrows/arrow-left-1.svg";

const useStyles = makeStyles((theme) => ({
    selectionContainer: {
        width: "100%",
        border: "1px solid " + theme.palette.borders.line.light,
        borderRadius: theme.spacing(0.75),
        marginTop: theme.spacing(1.5),
        justifyContent: "flex-start",
        padding: theme.spacing(2)
    },
    sticky: {
        position: "sticky",
        top: 0,
        backgroundColor: theme.palette.background.default,
        zIndex: 1,
        paddingBottom: theme.spacing(3.5)
    },
    backButtonContainer: {
        width: "100%",
        border: "1px solid " + theme.palette.borders.line.light,
        borderRadius: theme.spacing(0.75),
        backgroundColor: theme.palette.secondary["50"],
        justifyContent: "flex-start",
        padding: theme.spacing(2),
        marginTop: theme.spacing(5),
    },
}));

const CallUsResortList = ({resortsLoading, resorts, onResortChange, onBackButton}) => {
    const classes = useStyles();
    const {i18n} = useI18N();

    const handleResortId = (id) => {
        onResortChange(id);
    };

    return (
        <>
            <Box
                className={classes.sticky}
            >
                <Typography
                    variant="h3"
                    align="center"
                >
                    {i18n("dialog.contact.call_us.select_resort.title")}
                </Typography>

                <Button
                    className={classes.backButtonContainer}
                    onClick={() => onBackButton()}
                >
                    <Grid
                        container
                    >
                        <Grid
                            item
                            xs={2}
                        >
                            <Box
                                display="flex"
                                flexDirection={"column"}
                                justifyContent="center"
                                alignItems={"flex-start"}
                                height={"100%"}
                            >
                                <StreamlineIcon
                                    className={classes.arrowIconRight}
                                    size={24}
                                >
                                    <ArrowLeft />
                                </StreamlineIcon>
                            </Box>
                        </Grid>

                        <Grid
                            item
                            xs={10}
                        >
                            <Box
                                display="flex"
                                flexDirection={"column"}
                                justifyContent="center"
                                textAlign="left"
                                height={"100%"}
                            >
                                <Typography
                                    variant="subtitle1"
                                >
                                    {i18n("dialog.contact.call_us.resort_question.title")}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Button>
            </Box>

            <Box>
                {!resortsLoading && resorts?.length && resorts?.sort((a, b) => a.resortName.localeCompare(b.resortName))?.map(resort => {
                    return (
                        <Button
                            key={resort?.hapimagResortId}
                            className={classes.selectionContainer}
                            onClick={() => handleResortId(resort?.hapimagResortId)}
                        >
                            <Typography
                                variant="subtitle1"
                            >
                                {resort?.resortName}
                            </Typography>
                        </Button>
                    );
                })}

            </Box>
        </>
    );
};

CallUsResortList.propTypes = {
    resortsLoading: PropTypes.bool,
    resorts: PropTypes.array,
    onResortChange: PropTypes.func,
    onBackButton: PropTypes.func
};

export default CallUsResortList;
